// 将其他格式的日期数据转换成 年-月-日 时：分：秒
export function getDate(date) {
  const dateClass = typeof date
  let datas = null
  if (date !== '' && dateClass !== 'number') {
    // 1、将所有的日期数据转换成时间戳
    datas = new Date(Date.parse(date))
    // 2、根据时间戳分别解析出 年-月-日 时：分：秒
    const y = datas.getFullYear()
    const m = (+(datas.getMonth()) + 1) < 10 ? '0' + (+(datas.getMonth()) + 1) : (+(datas.getMonth()) + 1)
    const d = (datas.getDate() < 10 ? '0' + datas.getDate() : datas.getDate())
    const hh = (datas.getHours() < 10 ? '0' + datas.getHours() : datas.getHours())
    const mm = (datas.getMinutes() < 10 ? '0' + datas.getMinutes() : datas.getMinutes())
    const ss = (datas.getSeconds() < 10 ? '0' + datas.getSeconds() : datas.getSeconds())
    // 3、返回固定格式的数据
    return y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss
  } else if (date !== '' && dateClass === 'number') {
    datas = new Date(date)
    // 2、根据时间戳分别解析出 年-月-日 时：分：秒
    const y = datas.getFullYear()
    const m = (+(datas.getMonth()) + 1) < 10 ? '0' + (+(datas.getMonth()) + 1) : (+(datas.getMonth()) + 1)
    const d = (datas.getDate() < 10 ? '0' + datas.getDate() : datas.getDate())
    const hh = (datas.getHours() < 10 ? '0' + datas.getHours() : datas.getHours())
    const mm = (datas.getMinutes() < 10 ? '0' + datas.getMinutes() : datas.getMinutes())
    const ss = (datas.getSeconds() < 10 ? '0' + datas.getSeconds() : datas.getSeconds())
    // 3、返回固定格式的数据
    return y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss
  }
}

export function isvalidPhone (str) {
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  return reg.test(str)
}



// WEBPACK FOOTER //
// ./src/utils/index.js